import { getCookie, setCookie } from "./Helper";

export default class ViewSwitcher extends React.Component {
    constructor(props) {
        super(props);

        var isCompactViewCookie = getCookie("isCompactView");

        var isCompactView = false;

        if (isCompactViewCookie === "true") {
            isCompactView = true;
            setTimeout(this.onChange.bind(this), 1);
        }

        this.state = {
            isCompactView: isCompactView
        }
    }

    setGridView() {
        setCookie("isCompactView", false);

        this.setState({
            isCompactView: false
        }, this.onChange);
    }

    setListView() {
        setCookie("isCompactView", true);

        this.setState({
            isCompactView: true
        }, this.onChange);
    }

    onChange() {
        if (this.props.onChange) {
            this.props.onChange(this.state);
        }
    }

    render() {
        var gridViewActiveClass = " active";
        var listViewActiveClass = "";

        if (this.state.isCompactView) {
            gridViewActiveClass = "";
            listViewActiveClass = " active";
        }
        return <div className="btn-group btn-group-view-switcher">
                   <button type="button" className={"btn grid-view " + gridViewActiveClass} onClick={this.setGridView.bind(this)}><i className="icon icon-grid-view"></i>Grid view</button>
                   <button type="button" className={"btn list-view" + listViewActiveClass} onClick={this.setListView.bind(this)}><i className="icon icon-list-view"></i>Compact view</button>
               </div>;
    }

}